import { getCookie, getSessionStorage } from "../utils";

const getHeaders = () => {
  let headers = {
    AUTHORIZATION: "Token " + getCookie("user_key"),
  };
  return headers;
};

export { getHeaders };
